import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountingExpense } from "src/models/Accounting/Accounting.models";

interface AccountingExpenseState {
    accountExpenses: IAccountingExpense[];
    accountExpenseToEdit: IAccountingExpense | null;
}

const initialState: AccountingExpenseState = {
    accountExpenses: [],
    accountExpenseToEdit: null,
};

const AccountingExpensesSlice = createSlice({
    name: "AccountingExpense",
    initialState,
    reducers: {
        setAccountingExpenseList: (
            state,
            action: PayloadAction<IAccountingExpense[]>
        ) => {
            state.accountExpenses = action.payload;
        },
        concatListAccountingExpense: (
            state: AccountingExpenseState,
            action: PayloadAction<IAccountingExpense[]>
        ) => {
            state.accountExpenses = [
                ...state.accountExpenses.concat(action.payload),
            ];
        },
        setAccountingExpenseToEdit: (
            state,
            action: PayloadAction<IAccountingExpense | null>
        ) => {
            state.accountExpenseToEdit = action.payload;
        },
        addAccountingExpense: (state, action: PayloadAction<IAccountingExpense>) => {
            state.accountExpenses.push(action.payload);
        },
        updateAccountingExpense: (state, action: PayloadAction<IAccountingExpense>) => {
            let itemIndex = state.accountExpenses.findIndex(
                item => item.expenseId === action.payload.expenseId
            );
            if (itemIndex !== -1) state.accountExpenses[itemIndex] = action.payload;
        },
        deleteAccountingExpense: (state, action: PayloadAction<number>) => {
            const newArray = state.accountExpenses.filter(
                item => item.expenseId !== action.payload
            );
            state.accountExpenses = newArray;
        },
    },
});

export const {
    setAccountingExpenseList,
    concatListAccountingExpense,
    setAccountingExpenseToEdit,
    addAccountingExpense,
    updateAccountingExpense,
    deleteAccountingExpense
} = AccountingExpensesSlice.actions;

export default AccountingExpensesSlice.reducer;